import { ModalOpenButton } from "@msys/ui";
import { Icon, IconButton, Tooltip } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import SapLogo from "../../../assets/icons/sap-logo.svg?react";
import { useItemProductIsConfigurable } from "../../sap-s4-hana/hooks.js";
import { S4HanaKmatProductConfigModal } from "../../sap-s4-hana/S4HanaKmatProductConfigureModal.js";

interface Props {
  projectId: string;
  docId: string;
  itemId: string;
  articleNumber: string;
  manufacturerArticleNumber: string | null | undefined;
  materialBuyingPrice: number | null | undefined;
}

export const ProductSapConfigCell = ({
  projectId,
  docId,
  itemId,
  articleNumber,
  manufacturerArticleNumber,
  materialBuyingPrice,
}: Props) => {
  const { t } = useTranslate(["SapS4Hana"]);

  const { isConfigurable } = useItemProductIsConfigurable({
    itemProductArticleNumber: articleNumber,
    product: null,
    projectId,
    quoteId: docId,
    itemId,
  });

  if (!isConfigurable) return null;

  return (
    <ModalOpenButton
      Modal={S4HanaKmatProductConfigModal}
      modalProps={{
        projectId,
        quoteId: docId,
        itemId,
        productId: articleNumber,
        manufacturerArticleNumber,
        netPrice: materialBuyingPrice,
      }}
    >
      <Tooltip title={t("Configure product", { ns: "SapS4Hana" })}>
        <IconButton size="small" color="warning">
          <Icon>
            <SapLogo />
          </Icon>
        </IconButton>
      </Tooltip>
    </ModalOpenButton>
  );
};
